// Global Instructions Rule Applied!

import React, { useEffect, ReactNode } from 'react'
import { Provider } from 'react-redux'
import { store } from './store.ts'
import { ThemeProvider } from '../core/theme/ThemeProvider.jsx'
import { ErrorBoundary } from '../core/components/ErrorBoundary.jsx'
import { initAuthListener, checkExistingSession } from '../core/auth/authStateListener.js'

function AuthInitializer(): null {
  useEffect(() => {
    checkExistingSession(store.dispatch, store.getState)
    const cleanup = initAuthListener(store.dispatch, store.getState)
    return cleanup
  }, [])

  return null
}

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AuthInitializer />
        <ThemeProvider>{children}</ThemeProvider>
      </Provider>
    </ErrorBoundary>
  )
}
